import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {delay, distinctUntilChanged, mergeMap, takeUntil} from "rxjs/operators";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {User} from "../../../shared/interface/user";
import {merge, Observable, ReplaySubject} from "rxjs";
import {LogService} from "../../../shared/services/log.service";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {LoginLog} from "../../../shared/interface/login-log";
import {LoginLogService} from "../../../shared/services/login-log.service";
import {FilterService} from "../../../shared/services/filter.service";

@Component({
  selector: 'app-login-log-list',
  templateUrl: './login-log-list.component.html',
  styleUrls: ['./login-log-list.component.scss']
})
export class LoginLogListComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() user: Observable<User>;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  initialFilters: any;
  displayedColumns: string[] = ['createdAt', ];
  logs: LoginLog[];
  total: number;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private loginLogogService: LoginLogService,
    private filterService: FilterService,
  ) {
    this.loginLogogService.getLoginLogListSubject()
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((result: CountedAndPaginated<LoginLog>) => {
      this.logs = result.items;
      this.total = result.pagination.total;
    });
    this.parseFilters();
  }

  ngOnInit(): void {
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      user: 'string',
    }, filters);
  }

  buildFilters(user: User): any {
    const filters = {...this.initialFilters};

    filters.user = user.uuid;

    return filters;
  }
  ngAfterViewInit(): void {
      merge(this.user, this.paginator.page)
        .pipe(
          takeUntil(this.destroyed$),
          delay(0),
          mergeMap(() => this.user)
        )
        .subscribe((user: User) => {
          this.loginLogogService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.buildFilters(user));
        });
  }



    ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onImgError($event: ErrorEvent): void {
    // @ts-ignore
    $event.target.src = '/assets/avatar.png';
  }

}
